import type { FC, ReactNode } from "react";
import type React from "react";

import type { IconName } from "@similarweb/icons";
import { Banner } from "@similarweb/ui-components";
import type { ButtonType } from "@similarweb/ui-components";

import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";

export interface ITeaserBannerProps {
    title: ReactNode;
    subtitle?: string;
    buttonText?: string;
    buttonType?: ButtonType;
    onButtonClick?: VoidFunction;
    CustomIcon?: React.ReactNode;
    onCloseClick?: VoidFunction;
    buttonIconName?: IconName;
    customButton?: ReactNode;
}

export const TeaserBanner: FC<ITeaserBannerProps> = (props) => {
    const {
        title,
        subtitle,
        buttonText,
        buttonType = buttonTypes.PRIMARY,
        onButtonClick,
        onCloseClick,
        CustomIcon,
        buttonIconName,
        customButton,
    } = props;

    return (
        <div>
            <Banner
                title={title}
                subtitle={subtitle}
                buttonText={buttonText}
                buttonType={buttonType}
                onButtonClick={onButtonClick}
                CustomIcon={CustomIcon}
                onCloseClick={onCloseClick}
                buttonIconName={buttonIconName}
                CustomButton={customButton}
            />
        </div>
    );
};
